module.exports = __webpack_public_path__ + "img/Q.60858687.jpg";